
import {signinStatuses} from "../constants/signinOverlayConstants.js";

export const initialStateForSignin = {
	username: null,
	first: null,
	signinStatus: signinStatuses.NONE,
	showSigninOverlay: false,
	isStandAloneSignin: false,
	loading:false,
	errors:[],
	messages:[],
	primaryEmailHint: null
};
